import { Form, Timeline } from "antd";
import { useState } from "react";
import { useParams } from "react-router-dom";
import BlackDeleteIcon from "../../../assets/icons/BlackDeleteIcon";
import BookmarkIcon from "../../../assets/icons/BookmarkIcon";
import CommentIcon from "../../../assets/icons/CommentIcon";
import EnterIcon from "../../../assets/icons/EnterIcon";
import LinkIcon from "../../../assets/icons/LinkIcon";
import LoveIcon from "../../../assets/icons/LoveIcon";
import pic from "../../../assets/images/thumnails.png";
import useModal from "../../../hooks/useModal";
import AdminLayout from "../../../layouts/AdminLayout";

export default function CreateCommunityForum() {
  const { id } = useParams();
  const { open, handleOpen, toggle } = useModal();
  const [form] = Form.useForm();
  const [code, setCode] = useState("Start writing from here...");
  const [checkAll, setCheckAll] = useState(false);
  const handleCheckAll = (e: any) => {
    const checked = e.target.checked;
    setCheckAll(checked);
  };

  return (
    <AdminLayout
      title={`${id ? "Webinar Update" : "Create a New Webinar"}`}
      backLink="/admin/community-forum/forum"
    >
      <div className="bg-white p-4">
        <div className="flex-col justify-start items-start gap-6 inline-flex">
          <div className="self-stretch justify-between items-start inline-flex">
            <div className="flex-col justify-start items-start gap-[3px] inline-flex">
              <div className="text-[#343a40] text-xl font-bold font-['Encode Sans Condensed'] leading-[30px] tracking-wide">
                New Font Available Notification keeps popping up - how do I get
                rid of to
              </div>

              <div className="justify-start items-center gap-2 inline-flex">
                <div className="w-3 h-3 bg-[#ea868f]" />
                <p className="text-[#495057] text-sm font-medium font-['Encode Sans Condensed'] leading-snug tracking-wide">
                  Ask the community
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-6 custom_timeline">
          <Timeline
            items={[
              {
                children: (
                  <div>
                    <CreateCommunity />
                  </div>
                ),
              },
              {
                children: (
                  <div>
                    <SecondToLast />
                  </div>
                ),
              },
              {
                children: (
                  <div>
                    <SecondToLast />
                  </div>
                ),
              },
              {
                children: (
                  <div>
                    <SecondToLast />
                  </div>
                ),
              },
              {
                children: (
                  <div>
                    <SecondToLast />
                  </div>
                ),
              },
              {
                children: (
                  <div>
                    <SecondToLast />
                  </div>
                ),
              },
            ]}
          />
        </div>
      </div>

      <>
        <section className="dark:bg-gray-100 dark:text-gray-800">
          <div className="container max-w-5xl px-4 py-12 mx-auto">
            <div className="relative col-span-12 px-4 space-y-6 sm:col-span-9">
              <div className="col-span-12 space-y-12 relative px-4 sm:col-span-8 sm:space-y-8 sm:before:absolute sm:before:top-2 sm:before:bottom-0 sm:before:w-0.5 sm:before:-left-3 before:dark:bg-gray-300">
                <div className="flex flex-col sm:relative sm:before:absolute sm:before:top-2 sm:before:w-4 sm:before:h-4 sm:before:rounded-full sm:before:left-[-35px] sm:before:z-[1] before:dark:bg-violet-600">
                  <h3 className="text-xl font-semibold tracking-wide">
                    Donec porta enim vel
                  </h3>
                  <time className="text-xs tracking-wide uppercase dark:text-gray-600">
                    Dec 2020
                  </time>
                  <p className="mt-3">
                    Pellentesque feugiat ante at nisl efficitur, in mollis orci
                    scelerisque. Interdum et malesuada fames ac ante ipsum
                    primis in faucibus.
                  </p>
                </div>

                <div className="flex flex-col sm:relative sm:before:absolute sm:before:top-2 sm:before:w-4 sm:before:h-4 sm:before:rounded-full sm:before:left-[-35px] sm:before:z-[1] before:dark:bg-violet-600">
                  <h3 className="text-xl font-semibold tracking-wide">
                    Aliquam sit amet nunc ut
                  </h3>
                  <time className="text-xs tracking-wide uppercase dark:text-gray-600">
                    Jul 2019
                  </time>
                  <p className="mt-3">
                    Morbi vulputate aliquam libero non dictum. Aliquam sit amet
                    nunc ut diam aliquet tincidunt nec nec dui. Donec mollis
                    turpis eget egestas sodales.
                  </p>
                </div>

                <div className="flex flex-col sm:relative sm:before:absolute sm:before:top-2 sm:before:w-4 sm:before:h-4 sm:before:rounded-full sm:before:left-[-35px] sm:before:z-[1] before:dark:bg-violet-600">
                  <h3 className="text-xl font-semibold tracking-wide">
                    Pellentesque habitant morbi
                  </h3>
                  <time className="text-xs tracking-wide uppercase dark:text-gray-600">
                    Jan 2016
                  </time>
                  <p className="mt-3">
                    Suspendisse tincidunt, arcu nec faucibus efficitur, justo
                    velit consectetur nisl, sit amet condimentum lacus orci nec
                    purus. Mauris quis quam suscipit, vehicula felis id,
                    vehicula enim.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* <div className="p-6 bg-white ">
          <div className="relative cursor-pointer group">
            <div className="flex flex-col items-start">
              <div className="flex items-center space-x-2 ease-in-out duration-200 will-change-transform ">
                <div className="w-9 h-9 relative flex-none bg-gray-300 rounded-full">
                  <img
                    className="w-full h-full rounded-full"
                    src="https://i.pravatar.cc/36?img=51"
                    alt="..."
                  />
                </div>
                <div className="flex flex-start justify-center flex-col">
                  <CreateCommunity />
                </div>
              </div>
              <div className="flex item-start space-x-2">
                <div className="w-9 py-1 flex justify-center flex-none">
                  <div className="bg-gray-200 w-0.5  rounded-full" />
                </div>
                <div className="text-sm text-gray-500 mt-1 pb-6" />
              </div>
              <div className="absolute w-[calc(100%+8px)] h-[calc(100%-6px)] -left-2 -top-2 rounded-lg -z-10 ease-in-out duration-200 will-change-transform	group-hover:scale-[1.01] group-hover:bg-gray-50">
                #
              </div>
            </div>
          </div>

          <div className="relative cursor-pointer group">
            <div className="flex flex-col items-start">
              <div className="flex items-center space-x-2 ease-in-out duration-200 will-change-transform ">
                <div className="w-9 h-9 relative flex-none bg-gray-300 rounded-full">
                  <img
                    className="w-full h-full rounded-full"
                    src="https://i.pravatar.cc/36?img=68"
                    alt="..."
                  />
                </div>
                <div className="flex flex-start justify-center flex-col">
                  <SecondToLast />
                </div>
              </div>
              <div className="flex item-start space-x-2">
                <div className="w-9 py-1 flex justify-center flex-none">
                  <div className="bg-gray-200 w-0.5 h-full rounded-full" />
                </div>
                <p className="text-sm text-gray-500 mt-1 pb-6 ease-in-out duration-200 will-change-transform ">
                  The best performance improvement is the transition from the
                  nonworking state to the working state.
                </p>
              </div>
              <div className="absolute w-[calc(100%+8px)] h-[calc(100%-6px)] -left-2 -top-2 rounded-lg -z-10 ease-in-out duration-200 will-change-transform	group-hover:scale-[1.01] group-hover:bg-gray-50"></div>
            </div>
          </div>

          <div className="relative cursor-pointer group">
            <div className="flex flex-col items-start">
              <div className="flex items-center space-x-2 ease-in-out duration-200 will-change-transform ">
                <div className="w-9 h-9 relative flex-none bg-gray-300 rounded-full">
                  <img
                    className="w-full h-full rounded-full"
                    src="https://i.pravatar.cc/36?img=48"
                    alt="..."
                  />
                </div>
                <div className="flex flex-start justify-center flex-col">
                  <SecondToLast />
                </div>
              </div>
              <div className="flex item-start space-x-2">
                <div className="w-9 py-1 flex justify-center flex-none">
                  <div className="bg-gray-200 w-0.5 h-full rounded-full"></div>
                </div>
                <p className="text-sm text-gray-500 mt-1 pb-6 ease-in-out duration-200 will-change-transform ">
                  Don’t worry if it doesn’t work right. If everything did, you’d
                  be out of a job. (Mosher’s Law of Software Engineering)
                </p>
              </div>
              <div className="absolute w-[calc(100%+8px)] h-[calc(100%-6px)] -left-2 -top-2 rounded-lg -z-10 ease-in-out duration-200 will-change-transform	group-hover:scale-[1.01] group-hover:bg-gray-50"></div>
            </div>
          </div>
        </div> */}
      </>
    </AdminLayout>
  );
}

function SingleUserIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M9.99976 9.99902C10.9943 9.99902 11.9481 9.60394 12.6514 8.90067C13.3547 8.19741 13.7498 7.24359 13.7498 6.24902C13.7498 5.25446 13.3547 4.30063 12.6514 3.59737C11.9481 2.89411 10.9943 2.49902 9.99976 2.49902C9.00519 2.49902 8.05137 2.89411 7.34811 3.59737C6.64484 4.30063 6.24976 5.25446 6.24976 6.24902C6.24976 7.24359 6.64484 8.19741 7.34811 8.90067C8.05137 9.60394 9.00519 9.99902 9.99976 9.99902ZM12.4998 6.24902C12.4998 6.91206 12.2364 7.54795 11.7675 8.01679C11.2987 8.48563 10.6628 8.74902 9.99976 8.74902C9.33671 8.74902 8.70083 8.48563 8.23199 8.01679C7.76315 7.54795 7.49976 6.91206 7.49976 6.24902C7.49976 5.58598 7.76315 4.9501 8.23199 4.48126C8.70083 4.01242 9.33671 3.74902 9.99976 3.74902C10.6628 3.74902 11.2987 4.01242 11.7675 4.48126C12.2364 4.9501 12.4998 5.58598 12.4998 6.24902ZM17.4998 16.249C17.4998 17.499 16.2498 17.499 16.2498 17.499H3.74976C3.74976 17.499 2.49976 17.499 2.49976 16.249C2.49976 14.999 3.74976 11.249 9.99976 11.249C16.2498 11.249 17.4998 14.999 17.4998 16.249ZM16.2498 16.244C16.2485 15.9365 16.0573 15.0115 15.2098 14.164C14.3948 13.349 12.861 12.499 9.99976 12.499C7.13726 12.499 5.60476 13.349 4.78976 14.164C3.94226 15.0115 3.75226 15.9365 3.74976 16.244H16.2498Z"
        fill="white"
      />
    </svg>
  );
}

function CreateCommunity() {
  return (
    <>
      <div className="flex-col justify-start items-start gap-4 inline-flex">
        <div className="self-stretch flex-col justify-start items-start gap-2 flex">
          <div className="self-stretch justify-between items-end inline-flex">
            <p className="text-[#495057] text-base font-semibold leading-normal tracking-wide">
              Md Jubair Ahmed
            </p>
            <p className="text-right text-[#6c757d] text-sm font-semibold  leading-snug tracking-wide">
              5d
            </p>
          </div>

          <p className="self-stretch text-[#343a40] text-base font-normal leading-relaxed tracking-wide">
            Everytime I leave Figma window to go to another window, I get this
            “New available font: Raleway” notifications. Why is this happening?
            How do i turn it off?
          </p>
        </div>

        <img className="w-[566.25px] h-[270px]" src={pic} alt="..." />

        <div className="justify-start items-start gap-4 inline-flex">
          <div className="justify-start items-center gap-6 flex">
            <Action text="Comment" icon={<CommentIcon />} />
            <Action text="Like" icon={<LoveIcon />} />
            <Action text="Link Copt" icon={<LinkIcon />} />
            <Action text="Bookmark" icon={<BookmarkIcon />} />
          </div>
        </div>

        <div className="w-full px-2.5 py-1 bg-[#e9ecef] rounded">
          <p className="text-[#343a40] text-sm font-semibold leading-snug tracking-wide">
            16 Views
          </p>
        </div>
      </div>
    </>
  );
}

function SecondToLast() {
  return (
    <>
      <div className="flex-col justify-start items-start gap-4 inline-flex">
        <div className="self-stretch flex-col justify-start items-start gap-2 flex">
          <div className="self-stretch justify-between items-end inline-flex">
            <p className="text-[#495057] text-base font-semibold leading-normal tracking-wide">
              Md Jubair Ahmed
            </p>
            <p className="text-right text-[#6c757d] text-sm font-semibold  leading-snug tracking-wide">
              5d
            </p>
          </div>

          <div className="h-[26px] justify-start items-start gap-2 inline-flex">
            <div className="justify-start items-center gap-1.5 flex">
              <div className="w-4 h-4 relative">
                <span className=" left-[14.50px] top-[2px] origin-top-left rotate-180">
                  <EnterIcon />
                </span>
              </div>
              <div className="justify-start items-center gap-1.5 flex text-base font-encode leading-relaxed tracking-wide">
                <p className="text-[#0d6efd] font-medium">Md Jubair Ahmed</p>
                <p className="text-[#343a40] font-normal">
                  I hate this shit. Who knows how to off this stupid popup?
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="justify-start items-start gap-4 inline-flex">
          <div className="justify-start items-center gap-6 flex">
            <Action text="Reply" icon={<CommentIcon />} />
            <Action text="Like" icon={<LoveIcon />} />
            <Action icon={<BlackDeleteIcon color="#8897AE" />} />
          </div>
        </div>
      </div>
    </>
  );
}

function Action({ icon, text }: any) {
  return (
    <>
      <div className="justify-start items-center gap-1.5 flex cursor-pointer">
        <span>{icon}</span>
        <div className="text-[#6c757d] text-sm font-semibold font-['Encode Sans Condensed'] leading-snug tracking-wide">
          {text}
        </div>
      </div>
    </>
  );
}
